import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DraggableDialogPaperComponent from "../../common/components/DraggableDialogPaperComponent";
import { observer } from "mobx-react";
import { observable } from "mobx";
import _ from "lodash";
import { Snackbar, Switch, FormControlLabel } from "@material-ui/core";
import { TableRow, TableCell } from "@material-ui/core";
import { TableBody } from "@material-ui/core";
import { Table } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Editor } from "@tinymce/tinymce-react";
import { CircularProgress } from "@material-ui/core";

class ExtractDataDialog extends Component {
  state = observable({
    open: true,
    selection: {
      key: "",
      value: ""
    },
    template: {
      html: "",
      text: ""
    },
    delimiters: {},
    multipleRowsData: {
      type: "",
      data: {},
      options: {
        rowsPath: {},
        rowsPathString: ""
      }
    },
    isLoading: true
  });

  componentDidMount() {
    let { props } = this;

    this.state.selection.key = " {{" + this.props.column.alias_path + "}} ";
    this.state.selection.value =
      this.props.templateSelections[this.state.selection.key] || "";
    this.state.field = this.props.field || {};
    this.state.template = this.props.template;

    if (this.props.isMultipleRows) {
      let data = props.multipleRowsData.data[this.state.selection.key] || {};

      this.state.multipleRowsData.data = data;
      this.state.multipleRowsData.options = props.multipleRowsData.options;
      this.state.multipleRowsData.type = props.multipleRowsData.type;
    }
  }

  configEditorEvents = editor => {
    let me = this;

    editor.on("MouseUp", me.handleSelectionChange.bind(me, editor));
    editor.on("NodeChange", me.handleNodeChange.bind(me, editor));
  };

  handleNodeChange = editor => {
    if (this.state.isSelectionOnClickEnabled && this.state.isSelectedDataForFirstRow && !this.getIsMultipleRowsText()) {
      this.selectFirstRow(editor);
    }
  };

  handleSelectionChange = editor => {
    let me = this,
      selectedData = editor.selection.getContent(),
      replaceValue;

    if (selectedData) {
      let value = this.state.template.text;
      let regex = new RegExp(this.state.selection.key.slice(1, -1));
      if (!regex.test(value)) { // for selecting column
        this.state.selection.value = selectedData;

        if (me.props.isMultipleRows && me.state.multipleRowsData.type != "text") {
          this.findDelimitersForMultipleRows(editor);
        }
        replaceValue = ' <column>' +
          this.state.selection.key +
          "</column> ";

        if (editor.selection.getNode().innerText.trim() == selectedData.trim()) {
          let tag = editor.selection.getNode().tagName.toLowerCase(),
            element = document.createElement(tag);
          element.innerHTML = replaceValue;

          editor.selection.getNode().replaceWith(element);
        } else {
          editor.selection.setContent(replaceValue);
        }


        this.handleTemplateChange({
          target: editor
        });

        editor.selection.getSel().empty();
        setTimeout(me.validateMultipleRowsData, 500);
      } else if (this.state.isSelectedDataForFirstRow) {
        this.selectFirstRow(editor);
      } else if (this.state.isSelectedDataForLastRow) {
        this.selectLastRow(editor);
      }
    }
  };

  selectFirstRow = editor => {
    if (this.getIsMultipleRowsText()) {
      let row = this.escapeRegExp(
        editor.selection.getContent({
          format: "text"
        })
      ),
        data = editor.getContent({
          format: "text"
        }),
        newLineRegex = "(?:(?:[\\s-,+])+)",
        wordRegex = "\\S+",
        startDelimiter,
        rowSeparator,
        regex,
        regexWithoutStartDelimiter,
        m;

      startDelimiter = `(?<start>${wordRegex}?${newLineRegex}?${wordRegex}${newLineRegex})`;
      rowSeparator = `(?<separator>${newLineRegex})`;
      regex = new RegExp(startDelimiter + row + rowSeparator);
      regexWithoutStartDelimiter = new RegExp(`^${newLineRegex}?${row}${rowSeparator}`);
      if ((m = regex.exec(data)) !== null) {
        // console.log(m);
        this.state.multipleRowsData.options.rowSeparator = m.groups.separator;
        this.state.multipleRowsData.options.startDelimiter = m.groups.start;
      } else if ((m = regexWithoutStartDelimiter.exec(data)) !== null) {
        // console.log(m);
        this.state.multipleRowsData.options.rowSeparator = m.groups.separator;
        this.state.multipleRowsData.options.startDelimiter = "NO_START_DELIMITER";
      } else {
        Ext.Msg.alert("", "Invalid Row Selected, Please select again..");
        return;
      }

      this.state.isSelectedDataForFirstRow = false;
      this.state.isSelectedDataForLastRow = true;
      this.addFirstRowTagToSelectedContent(editor);
      Ext.Msg.alert("", "Row Selected. Please Select Last Row");
      return;
    }

    let node = editor.selection.getNode(),
      rowsPath,
      rowsPathString;

    if (node.tagName == "BODY") {
      return;
    }
    rowsPath = this.getPathTo(node);
    rowsPathString = this.getPathStringTo(node);

    if (
      rowsPathString.length > this.state.multipleRowsData.data.pathString.length
    ) {
      Ext.Msg.alert("", "Invalid Row Selected, Please select again..");
      return;
    }

    this.state.multipleRowsData.options.rowsPathString = rowsPathString;
    this.state.multipleRowsData.options.rowsPath = rowsPath;
    // this.state.multipleRowsData.options.rowsTagName = node.tagName.toLowerCase();
    this.state.isSelectedDataForFirstRow = false;
    this.addFirstRowClassToSelectedContet(editor);
    editor.selection.getSel().empty();
    Ext.Msg.alert("", "Row Selected");
  };

  addFirstRowTagToSelectedContent = editor => {
    editor.selection.setContent(
      '<firstrow>' +
      editor.selection.getContent() +
      "</firstrow>"
    );
  }

  addFirstRowClassToSelectedContet = editor => {
    let node = editor.selection.getNode();

    node.classList.add("first-row")
  }

  addLastRowTagToSelectedContent = editor => {
    editor.selection.setContent(
      '<lastrow>' +
      editor.selection.getContent() +
      "</lastrow>"
    );
  }

  addLastRowClassToSelectedContet = editor => {
    let node = editor.selection.getNode();

    node.classList.add("last-row")
  }

  escapeRegExp = string => {
    return string.replace(/[.*+?^${}()|[\]\\\/]/g, "\\$&");
  };

  getIsMultipleRowsText = () => {
    return this.state.multipleRowsData.type == "text";
  };

  selectLastRow = editor => {
    if (this.getIsMultipleRowsText()) {
      let row = this.escapeRegExp(editor.selection.getContent(
        {
          format: "text"
        }
      )),
        data = editor.getContent(
          {
            format: "text"
          }
        ),
        newLineRegex = "(?:(?:[\\s-,+])+)",
        wordRegex = "\\S+",
        endDelimiter,
        regex,
        regexWithoutEndDelimiter,
        m;

      endDelimiter = `(?<end>${newLineRegex}${wordRegex}${newLineRegex}?${wordRegex}?${newLineRegex}?${wordRegex}?)`;
      regex = new RegExp(row + endDelimiter);
      regexWithoutEndDelimiter = new RegExp(`${row}${newLineRegex}?$`)

      if ((m = regex.exec(data)) !== null) {
        this.state.multipleRowsData.options.endDelimiter = m.groups.end;
      } else if ((m = regexWithoutEndDelimiter.exec(data)) !== null) {
        this.state.multipleRowsData.options.endDelimiter = "NO_END_DELIMITER";
      } else {
        Ext.Msg.alert("", "Invalid Last Row Selected, Please select again..");
        return;
      }

      this.state.isSelectedDataForLastRow = false;
      this.addLastRowTagToSelectedContent(editor);
      Ext.Msg.alert("", "Last Row Selected");
      return;
    }
  };

  findDelimitersForMultipleRows = editor => {
    //finding for tables
    let me = this,
      html = this.state.template.html,
      selectedNode = editor.selection.getNode(),
      data = {};

    if (selectedNode.tagName == "TD" || selectedNode.closest("td")) {
      data = this.findDelimitersForMultipleRowsInTable(editor);
    } else {
      data = {
        ...this.state.multipleRowsData,
        type: this.getIsMultipleRowsText() ? "text" : "others",
        data: {
          path: me.getPathTo(selectedNode),
          pathString: me.getPathStringTo(selectedNode)
        }
      };
    }

    this.state.multipleRowsData = data;

    return data;
  };

  findDelimitersForMultipleRowsInTable = (editor) => {
    let me = this,
      selectedNode = editor.selection.getNode(),
      doc = selectedNode.getRootNode(),
      tables = doc.getElementsByTagName("table"),
      tableNumber;

    for (let i = 0; i < tables.length; i++) {
      if (tables[i] == selectedNode.closest("table")) {
        tableNumber = i + 1;
        break;
      }
    }
    return {
      type: this.state.multipleRowsData.type || (selectedNode.tagName == "TD" ? "table" : "others"),
      options: {
        count: tableNumber,
        rowsPath: (this.state.multipleRowsData.options.rowsPath || {}),
        rowsPathString: (this.state.multipleRowsData.options.rowsPathString || "")
      },
      data: {
        column: selectedNode.closest('td').cellIndex,
        row: selectedNode.closest('tr').rowIndex,
        path: me.getPathTo(selectedNode),
        pathString: me.getPathStringTo(selectedNode)
      }
    }
  }

  getPathTo = (element, output = []) => {
    if (element.id !== "") {
      if (element.id == "tinymce") {
        output.unshift({
          tag: "body"
        });
        return output;
      }
      // output.unshift({ // disabled id
      //   id: element.id ,
      // });
      // return output;
    }

    if (element.className == "gmail_quote") {
      output.unshift({
        tag: "body"
      });
      return output;
    }

    var ix = 0;
    var siblings = element.parentNode.childNodes;
    for (var i = 0; i < siblings.length; i++) {
      var sibling = siblings[i];

      if (sibling === element) {
        output.unshift({
          tag: element.tagName.toLowerCase(),
          count: ix
        });
        return this.getPathTo(element.parentNode, output);
      }

      if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
        ix++;
      }
    }
  };

  getPathStringTo = element => {
    if (element.id !== "") {
      if (element.id == "tinymce") {
        return "body";
      }
      // return "//*[@id='" + element.id + "']"; //disabled id
    }

    if (element.className == "gmail_quote")
      return element.tagName.toLowerCase();

    if (element === document.body) return element.tagName.toLowerCase();

    var ix = 0;
    var siblings = element.parentNode.childNodes;
    for (var i = 0; i < siblings.length; i++) {
      var sibling = siblings[i];

      if (sibling === element) {
        return (
          this.getPathStringTo(element.parentNode) +
          "/" +
          element.tagName.toLowerCase() +
          "[" +
          (ix + 1) +
          "]"
        );
      }

      if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
        ix++;
      }
    }
  };

  getElementByXPath = (path, documentElement) => {
    return new XPathEvaluator().evaluate(
      path,
      documentElement,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;
  };

  handleSave = () => {
    let me = this,
      regex = new RegExp(this.state.selection.key.slice(1, -1)),
      template = this.state.template;

    if (!regex.test(template.text)) {
      Ext.Msg.alert("Error", "Please Select the column");
      return;
    }

    if (!me.validateMultipleRowsData()) {
      return;
    }

    this.props.onChange(template);
    this.props.onSelectionChange(
      this.state.selection.key,
      this.state.selection.value
    );
    if (this.props.isMultipleRows) {
      this.props.onMultipleRowsDataChange(
        this.state.multipleRowsData,
        this.state.selection.key
      );
    }
    this.state.open = false;
  };

  validateMultipleRowsData = () => {
    let me = this,
      type,
      options,
      columnData;

    if (!me.props.isMultipleRows) {
      return true;
    }

    type = me.state.multipleRowsData.type;
    options = me.state.multipleRowsData.options;
    columnData = me.state.multipleRowsData.data;

    if (type == "others" || type == "table") {
      if (!options.rowsPathString) {
        Ext.Msg.alert("Alert", "Please Select the first repeating row");
        me.state.isSelectedDataForFirstRow = true;
        return false;
      }
      if (options.rowsPathString.length > columnData.pathString.length) {
        Ext.Msg.alert(
          "Alert",
          "Invalid first row selected. Please Select the first repeating row"
        );
        this.state.isSelectedDataForFirstRow = true;
        return false;
      }
    }

    if (me.getIsMultipleRowsText()) {
      if (!options.startDelimiter || !options.rowSeparator) {
        Ext.Msg.alert("Alert", "Please Select the first repeating row");
        me.state.isSelectedDataForFirstRow = true;
        return false;
      } else if (!options.endDelimiter) {
        Ext.Msg.alert("Alert", "Please Select the last row");
        me.state.isSelectedDataForLastRow = true;
        return false;
      }
    }

    return true;
  };

  handleTemplateChange = ev => {
    this.state.template.html = ev.target.getContent();
    this.state.template.text = ev.target.getContent({
      format: "text"
    });
  };

  shouldShowReselectRow = () => {
    let type = this.state.multipleRowsData.type,
      options = this.state.multipleRowsData.options;

    switch (type) {
      case "others":
        return !!options.rowsPathString;
      case "text":
        return (
          !!options.startDelimiter && !!options.endDelimiter && !!options.rowSeparator
        );
    }

    return false;
  };

  reselectRow = () => {
    let me = this,
      template = me.editor.getContent(),
      regex;

    me.state.isSelectedDataForFirstRow = true;

    regex = /(\<firstrow\>)|(\<\/firstrow\>)|(\<lastrow\>)|(\<\/lastrow\>)|(class="first-row")|(( ?)first-row( ?))|(class="last-row")|(( ?)last-row( ?))/gi;
    template = template.replace(regex, '');
    me.editor.setContent(template);
  }

  enableSelectionOnClick = () => {
    this.state.isSelectionOnClickEnabled = !this.state.isSelectionOnClickEnabled;
  }

  render() {
    const me = this,
      props = this.props,
      { store } = props;
    return (
      <Dialog
        open={this.state.open}
        // onClose={handleClose}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
        fullWidth={true}
      >
        <DialogContent>
          <Typography variant="h6">Extract Data </Typography>
          <Typography variant="body1">
            {" "}
            Enter sample email content here.{" "}
            <span style={{ backgroundColor: "yellow" }}>Highlight</span> the
            parts which you wish to extract.{" "}
          </Typography>
          {this.state.isLoading && <CircularProgress disableShrink />}
          {props.isMultipleRows && (
            <FormControlLabel
              value="start"
              control={
                <Switch
                  checked={!this.getIsMultipleRowsText()}
                  onChange={ev => {
                    this.state.multipleRowsData.type = !ev.target.checked
                      ? "text"
                      : "others";
                    // store.handleCurrentTemplateChange(ev.target.checked, "is_multiple_rows")
                  }}
                // xs={1}
                ></Switch>
              }
              label="Is HTML Approach?"
              labelPlacement="start"
            />
          )}
          {(this.state.multipleRowsData.type != "text") && (this.state.multipleRowsData.options.rowsPathString.search("tr") !== -1) && (
            <FormControlLabel
              value="start"
              control={
                <Switch
                  checked={this.state.multipleRowsData.type == "table"}
                  onChange={ev => {
                    this.state.multipleRowsData.type = !ev.target.checked
                      ? "others"
                      : "table";
                    // store.handleCurrentTemplateChange(ev.target.checked, "is_multiple_rows")
                  }}
                // xs={1}
                ></Switch>
              }
              label="Is plain table?"
              labelPlacement="start"
            />
          )}
          <Editor
            initialValue={props.template.html}
            // initialValue="<p>paste body</p>"
            apiKey="qnjxik5m7hnatzahksumpbi3v9a6oxgfcc22fyjovjh62zps"
            init={{
              height: 500,
              menubar: false,
              menubar: false,
              entity_encoding: "named",
              custom_elements: "~column,~firstrow,~lastrow",
              // cleanup_on_startup: false,
              // trim_span_elements: false,
              // verify_html: false,
              // cleanup: false,
              // convert_urls: false,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media paste code help wordcount"
              ],
              // paste_enable_default_filters: false,
              // paste_filter_drop: false,
              // paste_merge_formats: false,
              // paste_convert_word_fake_lists: false,
              // paste_remove_styles_if_webkit: false,
              toolbar: "",
              content_style: "* { font-size: 12px; }",
              content_css: baseUrl + '/css/user/tinymce.css',
              init_instance_callback: editor => {
                this.editor = editor;

                this.configEditorEvents(editor);
              },
              setup: ed => {
                ed.on("init", args => {
                  this.state.isLoading = false;
                });
              }
            }}
            onChange={this.handleTemplateChange}
          />
          {false && props.isMultipleRows &&
            this.state.multipleRowsData &&
            this.state.multipleRowsData.data && (
              <Table className="test_parser_output_table">
                <TableBody>
                  <TableRow>
                    {this.state.multipleRowsData.data &&
                      Object.entries(this.state.multipleRowsData.data).map(
                        ([key, val]) => {
                          return (
                            <TableCell key={key}>
                              {" "}
                              <Typography variant="h6">{key}</Typography>{" "}
                            </TableCell>
                          );
                        }
                      )}
                  </TableRow>
                  <TableRow>
                    {this.state.multipleRowsData.data &&
                      Object.entries(this.state.multipleRowsData.data).map(
                        ([key, val]) => {
                          return (
                            <TableCell key={key}>
                              <Typography variant="body1">
                                {" "}
                                {typeof val == "string" ? val : ""}{" "}
                              </Typography>
                            </TableCell>
                          );
                        }
                      )}
                  </TableRow>
                </TableBody>
              </Table>
            )}
          {/* 
          <Snackbar
            ContentProps={{
              'aria-describedby': 'snackbar-fab-message-id',
              'role': 'alertdialog',
            }}
            message={<span id="snackbar-fab-message-id">Archived</span>}
            action={
              <Button color="inherit" size="small">
                Undo
              </Button>
            }
          /> */}
        </DialogContent>
        <DialogActions>
          {(me.state.isSelectedDataForFirstRow || me.state.isSelectedDataForLastRow) && (
            <Button
              onClick={me.enableSelectionOnClick}
              color="primary"
            >
              {me.state.isSelectionOnClickEnabled ? "Disable" : "Enable"} Selection on Click
            </Button>
          )}
          {me.shouldShowReselectRow() && (
            <Button
              onClick={me.reselectRow}
              color="primary"
            >
              Reselect Row
            </Button>
          )}

          <Button
            onClick={() => {
              let me = this,
                // codemirrorCmp = me.cm.getCodeMirror(),
                replaceValue = me.state.selection.value;

              me.editor.setContent(
                me.editor
                  .getContent()
                  .replace(
                    '<column>' +
                    me.state.selection.key +
                    "</column>",
                    replaceValue
                  )
              );
              me.handleTemplateChange({
                target: me.editor
              });
              // me.parseMatches();
            }}
            color="primary"
          >
            Undo Selection
          </Button>

          <Button
            onClick={() => {
              this.state.open = false;
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={this.handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default observer(ExtractDataDialog);
